import { render, staticRenderFns } from "./PinPuk.vue?vue&type=template&id=1f02f3bc&scoped=true&"
import script from "./PinPuk.vue?vue&type=script&lang=js&"
export * from "./PinPuk.vue?vue&type=script&lang=js&"
import style0 from "./PinPuk.vue?vue&type=style&index=0&id=1f02f3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f02f3bc",
  null
  
)

export default component.exports